<template>
	<tr>
		<td style="vertical-align: middle" :width="colWidths[0]" class="text-left">
			<div class="d-flex align-center">
				<!-- <v-icon small class="mr-1 cost_table_item_drag_handler" color="black">mdi-unfold-more-horizontal</v-icon> -->
				<v-form ref="formconcept_filled" style="width: 100%;">
					<v-select
						v-model="localCostItem.stage_id"
						:items="additionalStages"
						:menu-props="{ top: true, offsetY: true }"
						item-text="name"
						item-value="id"
						:label="inputLabel"
						class="custom-height-search custom-height-calendar mt-2"
						outlined
						dense
						hide-details
						style="font-size: 14px;"
						required
						return-object
						:rules="requiredRule"
						@change="onChangeStage"
					>
					</v-select>
					<div class="d-flex justify-center align-center" style="gap: 10px;">
						<p class="mb-0 caption" :class="localCostItem.active ? 'grey--text' : ''">Incluir en Notas</p>
						<v-btn
							class="px-0"
							icon
							depressed
							small
							:color="localCostItem.active ? 'success' : '#959595'"
							@click="changeStageStatus"
						>
							<v-icon large>{{localCostItem.active ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline'}}</v-icon>
						</v-btn>
						<p class="mb-0 caption" :class="localCostItem.active ? '' : 'grey--text'">Incluir en Tabla de Costo</p>
					</div>
					<!-- <v-text-field
						v-model="localCostItem.name"
						:label="inputLabel"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar"
						style="font-size: 14px;"
						:style="'padding-left: ' + paddingLevelForFirstElement"
						:rules="requiredRule"
						@input="debounceEmitChange"
					></v-text-field> -->
				</v-form>
				<div class="d-flex align-center justify-center ml-2" style="min-width: 24px;">
					<v-tooltip bottom v-if="showSubitems">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								x-small
								color="black"
								@click="toggleToShowDetails(localCostItem.id)"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon size="22">mdi-chevron-down</v-icon>
							</v-btn>
						</template>
						<span>Ver Detalle</span>
					</v-tooltip>
				</div>
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 100px;" :width="colWidths[1]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.qty"
						type="text"
						:label="isM2Selection ? 'Superficie':'Cantidad'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@input="sanitizeQty"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable && currency == 'uf'">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.unit_cost_uf"
					type="text"
						:label="isM2Selection ? 'Valor x M² (UF)':'Monto (UF)'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@input="sanitizeUF"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
				{{costItemSummary.unit_cost_uf | toThousandFilter(2)}}
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable && currency == 'clp'">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.unit_cost_clp"
						type="number"
						step="1"
						:label="isM2Selection ? 'Valor x M² (CLP)':'Monto (CLP)'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@keypress="blockDecimals"
						@input="sanitizeIntegerInput"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
				${{costItemSummary.unit_cost_clp | toThousandFilter}}
			</div>
		</td>
		<td style="vertical-align: middle;" :width="colWidths[4]" class="text-right">
			{{costItemSummary.total_cost_uf | toThousandFilter(2)}}
		</td>
		<td style="vertical-align: middle;" :width="colWidths[5]" class="text-right">
			${{Math.round(costItemSummary.total_cost_clp) | toThousandFilter}}
		</td>
		<td style="vertical-align: middle;" :width="colWidths[6]" class="text-center">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						x-small
						color="error"
						@click="deleteItem"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon small dark>mdi-delete-outline</v-icon>
					</v-btn>
				</template>
				<span>Eliminar Item</span>
			</v-tooltip>
		</td>
	</tr>
</template>

<script>
import _debounce from 'lodash/debounce'
import {getAllProjectPlanningStages} from '@/helpers/api/projects'

export default {
	name: 'CostItemSingleStage',
	props: {
		costItem: {
			type: Object,
			required: true
		},
		isM2Selection: {
			type: Boolean,
			default: false
		},
		isEditable: {
			type: Boolean,
			default: true
		},
		showSubitems: {
			type: Boolean,
			default: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		colWidths: {
			type: Array,
			required: true
		},
		itemLevel: {
			type: Number,
			default: 1
		},
		inputLabel: {
			type: String,
			default: 'Item'
		},
		currency: {
			type: String,
			required: true
		},
	},
	computed: {
		additionalStages(){
			return this.additionalStagesTemp
		},
		paddingLevelForFirstElement(){
			const basePadding = 8
			const padding = basePadding * this.itemLevel
			return padding + '%'
		},
		costItemSummary() {
			const parse = (n) => parseFloat(n) || 0;

			const summarizeItems = (items) => {
				return items.reduce(
					(acc, item) => {
						if (Array.isArray(item.subitems) && item.subitems.length > 0) {
							const subTotals = summarizeItems(item.subitems);
							acc.qty += subTotals.qty;
							acc.unit_cost_uf += subTotals.unit_cost_uf;
							acc.unit_cost_clp += subTotals.unit_cost_clp;
							acc.total_cost_uf += subTotals.total_cost_uf;
							acc.total_cost_clp += subTotals.total_cost_clp;
						} else {
							const qty = parse(item.qty);
							const uf = parse(item.unit_cost_uf);
							const clp = parse(item.unit_cost_clp);

							acc.qty += qty;
							acc.unit_cost_uf += uf;
							acc.unit_cost_clp += clp;
							acc.total_cost_uf += uf * qty;
							acc.total_cost_clp += clp * qty;
						}

						return acc;
					},
					{
						qty: 0,
						unit_cost_uf: 0,
						unit_cost_clp: 0,
						total_cost_uf: 0,
						total_cost_clp: 0
					}
				);
			};

			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			if (Array.isArray(this.localCostItem.subitems)) {
				const subitemTotals = summarizeItems(this.localCostItem.subitems);
				Object.keys(totals).forEach(k => {
					totals[k] += subitemTotals[k];
				});
			}

			if (Array.isArray(this.localCostItem.items)) {
				const itemTotals = summarizeItems(this.localCostItem.items);
				Object.keys(totals).forEach(k => {
					totals[k] += itemTotals[k];
				});
			}

			if (
				!Array.isArray(this.localCostItem.subitems) &&
				!Array.isArray(this.localCostItem.items)
			) {
				const qty = parse(this.localCostItem.qty);
				const uf = parse(this.localCostItem.unit_cost_uf);
				const clp = parse(this.localCostItem.unit_cost_clp);

				totals.qty += qty;
				totals.unit_cost_uf += uf;
				totals.unit_cost_clp += clp;
				totals.total_cost_uf += uf * qty;
				totals.total_cost_clp += clp * qty;
			}

			return totals;
		}
	},
	watch: {
		costItem: {
			handler(newValue) {
				// if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
				this.localCostItem = { ...newValue }
				if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
					this.setItemClpValueFromUf()
				}
			},
			deep: true,
			immediate: false,
		},
		ufValue: {
			handler() {
				if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
					this.setItemClpValueFromUf()
				}
			},
			immediate: true
		}
	},
	data(){
		return {
			showDetails: [],
			additionalStagesTemp: [],
			loadingAdditionalStages: false,
			localCostItem: {...this.costItem},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
		}
	},
	mounted(){
		this.getAdditionalStages()
		this.$nextTick(() => {
			if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
				this.setItemClpValueFromUf()
			}
		})
	},
	methods: {
		debounceEmitChange: _debounce(function() { this.emitChange() }, 50),
		emitChange(){
			this.$emit('change', { ...this.localCostItem })
		},
		changeStageStatus(){
			this.localCostItem.active = !this.localCostItem.active
			this.$emit('change', { ...this.localCostItem })
		},
		onChangeStage(stage){
			this.localCostItem = {...this.localCostItem, ...{
				stage_id: stage ? stage.id : null,
				stage
			}}
			this.$emit('change', { ...this.localCostItem })
		},
		async getAdditionalStages(){
			this.loadingAdditionalStages = true
			const data = {}
			const stages = await getAllProjectPlanningStages(data)
			if(stages.code == 200){
				this.additionalStagesTemp = stages.project_planning_stages
			}
			this.loadingAdditionalStages = false
		},
		blockDecimals(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
		},
		sanitizeQty() {
			const value = String(this.localCostItem.qty ?? '')
				.replace(/\D/g, '')
				.replace(/^0+(?!$)/, '')
			this.localCostItem = {
				...this.localCostItem,
				qty: value
			}
			this.debounceEmitChange()
		},
		sanitizeUF() {
			let value = String(this.localCostItem.unit_cost_uf ?? '');
			value = value.replace(',', '.');
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			this.localCostItem = {
				...this.localCostItem,
				unit_cost_uf: value
			};
			if (value !== '' && !value.endsWith('.')) {
				this.setItemClpValueFromUf();
			}
		},
		sanitizeIntegerInput() {
			this.localCostItem = {
				...this.localCostItem,
				unit_cost_clp: this.localCostItem.unit_cost_clp
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setItemUfValueFromClp()
		},
		setItemClpValueFromUf(){
			if(this.localCostItem.from_change == 'clp') return
			const clp_value = this.localCostItem.unit_cost_uf * this.ufValue
			this.localCostItem = {...this.localCostItem, ...{unit_cost_clp: parseFloat(clp_value), from_change: 'uf'}}
			this.$emit('change', { ...this.localCostItem })
			// this.debounceEmitChange()
		},
		setItemUfValueFromClp(){
			const uf_value = this.localCostItem.unit_cost_clp / this.ufValue
			this.localCostItem = {...this.localCostItem, ...{unit_cost_uf: parseFloat(uf_value), from_change: 'clp'}}
			this.$emit('change', { ...this.localCostItem })
			// this.debounceEmitChange()
		},
		toggleToShowDetails(item_id) {
			this.$emit('onToggleShowDetails', item_id)
		},
		deleteItem(){
			this.$emit('change', null)
		},
	}
}
</script>

<style scoped>
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.square-btn {
		width: 24px !important;
		height: 24px !important;
		min-width: 0 !important;  /* evita que Vuetify imponga min-width de 64px */
		padding: 0 !important;    /* elimina el padding interno */
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.cost_table_item_drag_handler{cursor: grab;}
</style>